import { getSessionUUID } from '../components/lib/AuthToken'; // Import the utility function
import logger from "../utils/logger";


export const fetch_all_vehicles = async () => {
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
        };

        // Send Request to backend
        const response = await fetch('/vehicles/get_all_vehicles', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error fetching vehicles:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const fetch_vehicle_by_reg = async (vehicle_reg) => {
    try {

        const sessionToken = await getSessionUUID(); // Assume this gets a valid session token.

        // Send request to the backend with query parameters
        const response = await fetch(`/vehicles/get_vehicle_by_reg?reg=${encodeURIComponent(vehicle_reg)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });

        const responseBody = await response.json();

        return {
            message: responseBody.error || 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error fetching vehicle:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};


//-------------------------------------------------------------------------------------------------

export const suspend_vehicle = async (vehicle_id, new_status) => {
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ 'vehicle_id': vehicle_id, 'new_status': new_status })
        };

        // Send Request to backend
        const response = await fetch('/vehicles/suspend_vehicle', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error updating vehcile:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const update_vehicle = async (vehicle_data) => {
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ vehicle_data })
        };

        // Send Request to backend
        const response = await fetch('/vehicles/update_vehicle', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error updating vehiclee:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const use_update_service_dates = async (vehicle_data) => {
    try {

        const sessionToken = await getSessionUUID(); // Use the utility function

        // Options to send data to backend
        const requestOptions = {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ vehicle_data })
        };

        // Send Request to backend
        const response = await fetch('/vehicles/update_vehicle_service', requestOptions);
        const responseBody = await response.json();

        // Return the message and status
        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null, // Include data if provided
        };
    } catch (err) {
        logger.error("Error updating vehicle:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------


export const add_vehicle = async (vehicle_reg, type) => {

    try{
        logger.log("Adding vehicle to system: ", vehicle_reg);
        // User input
        const body = {
            reg: vehicle_reg,
            type: type,
        };

        // Options to send data to backend
        const sessionToken = await getSessionUUID();
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify(body),
        };

        // Send Request to backend and log any errors
        const response = await fetch('/vehicles/add_vehicle', requestOptions);
        const responseBody = await response.json();

        if (response.status === 201 || response.status === 200) {
            // Show success message with server response
            return { message: responseBody.message || 'Vehicle Added Successfully', status: response.status };
        } else {
            // Show error message with server response
            return { message: responseBody.error || 'Failed to create vehicle', status: response.status };
        }
    } catch (err) {
        logger.error("Error updating vehiclee:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
}

//-------------------------------------------------------------------------------------------------

export const fetch_monthly_checks = async (range, vehicleId) => {
    try {

        const sessionToken = await getSessionUUID(); // Assume this gets a valid session token.

        // Send request to the backend with query parameters
        const response = await fetch(`/vehicles/get_monthly_checks?range=${encodeURIComponent(range)}&vehicle_id=${vehicleId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });

        const responseBody = await response.json();

        return {
            message: responseBody.error || 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error fetching vehicle:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const fetch_driver_checks = async (driverId, startDate, endDate) => {
    try {
        const sessionToken = await getSessionUUID();
        const queryParams = new URLSearchParams({
            driver_id: driverId,
            start_date: startDate,
            end_date: endDate,
        });

        const response = await fetch(`/vehicles/get_driver_checks?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });
        const responseBody = await response.json();

        return {
            message: responseBody.error || 'Request successful',
            status: response.status,
            data: response.ok ? responseBody : null,
        };
    } catch (err) {
        logger.error('Error fetching driver vehicle checks:', err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
            data: null,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const download_monthly_checks_report = async (range, vehicleId) => {
    try {
        const sessionToken = await getSessionUUID();

        const response = await fetch(`/vehicles/download_monthly_checks_report?range=${encodeURIComponent(range)}&vehicle_id=${vehicleId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });

        if (!response.ok) {
            let message = 'Failed to download monthly report';
            try {
                const body = await response.json();
                message = body.error || message;
            } catch (error) {
                logger.warn('Could not parse monthly report error response', error);
            }
            return { status: response.status, message };
        }

        const blob = await response.blob();
        const contentDisposition = response.headers.get('content-disposition') || '';
        const match = contentDisposition.match(/filename=\"?([^\";]+)\"?/i);
        const fileName = (match && match[1]) ? match[1] : 'Monthly_Vehicle_Checks_Report.pdf';

        return {
            status: response.status,
            data: blob,
            fileName,
            message: 'Report downloaded successfully',
        };
    } catch (err) {
        logger.error('Error downloading monthly vehicle checks report:', err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const fetch_vehicle_lease_report_data = async (range) => {
    try {
        const sessionToken = await getSessionUUID();

        const queryParams = new URLSearchParams({
            range: range,
        });

        const response = await fetch(`/vehicles/get_vehicle_lease_report?${queryParams.toString()}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });

        const responseBody = await response.json();

        return {
            message: responseBody.error || 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error fetching fire register report data: ", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const fetch_defect_types_for_vehicle_type = async (vehicleType) => {
    try {
        const sessionToken = await getSessionUUID();

        const response = await fetch(`/vehicles/get_defect_types/${encodeURIComponent(vehicleType)}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });

        const responseBody = await response.json();

        return {
            message: responseBody.error || 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error fetching defect types for vehicle type:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------

export const fetch_active_vehicles_report = async (startDate, endDate) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({
                startDate,
                endDate
            }),
        };

        const response = await fetch('/vehicles/get_active_vehicles_report', requestOptions);
        const responseBody = await response.json();

        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error fetching active vehicles report:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

//-------------------------------------------------------------------------------------------------
// Vehicle Files (VTG7 upload + Audit)
//-------------------------------------------------------------------------------------------------

export const upload_vtg7 = async (vehicleId, file, displayName = '') => {
    try {
        const sessionToken = await getSessionUUID();
        const formData = new FormData();
        formData.append('file', file);
        formData.append('vehicle_id', vehicleId);
        if (displayName) formData.append('display_name', displayName);

        const response = await fetch('/vehicle_files/upload_vtg7', {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${sessionToken}` },
            body: formData,
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error('Error uploading VTG7:', err);
        return { status: 500, message: err.message || 'An error occurred' };
    }
};

//-------------------------------------------------------------------------------------------------

export const fetch_vehicle_files = async (vehicleId) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch(`/vehicle_files/get_vehicle_files/${vehicleId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error('Error fetching vehicle files:', err);
        return { status: 500, message: err.message || 'An error occurred' };
    }
};

//-------------------------------------------------------------------------------------------------

export const delete_vehicle_file = async (fileId) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch(`/vehicle_files/delete_vehicle_file/${fileId}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error('Error deleting vehicle file:', err);
        return { status: 500, message: err.message || 'An error occurred' };
    }
};

//-------------------------------------------------------------------------------------------------

export const get_vtg7_signed_url = async (filePath) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/vehicle_files/get_vtg7_signed_url', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify({ file_path: filePath }),
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error('Error getting VTG7 signed URL:', err);
        return { status: 500, message: err.message || 'An error occurred' };
    }
};

//-------------------------------------------------------------------------------------------------

export const generate_vehicle_qr = async (vehicleId, vehicleReg) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/vehicles/generate-qr', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
            body: JSON.stringify({ vehicle_id: vehicleId }),
        });

        if (!response.ok) {
            let message = 'Failed to generate QR code';
            try {
                const body = await response.json();
                message = body.error || message;
            } catch (_) {}
            return { status: response.status, message };
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `QR_${vehicleReg || vehicleId}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        return { status: 200, message: 'QR code downloaded successfully' };
    } catch (err) {
        logger.error('Error generating vehicle QR code:', err);
        return { status: 500, message: err.message || 'An error occurred' };
    }
};

//-------------------------------------------------------------------------------------------------

export const download_vehicle_audit = async (vehicleId, vehicleReg) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch(`/vehicle_files/download_vehicle_audit/${vehicleId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });

        if (!response.ok) {
            let message = 'Failed to download vehicle audit';
            try {
                const body = await response.json();
                message = body.error || message;
            } catch (_) {}
            return { status: response.status, message };
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Vehicle_Audit_${vehicleReg || vehicleId}.pdf`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        return { status: 200, message: 'Audit downloaded successfully' };
    } catch (err) {
        logger.error('Error downloading vehicle audit:', err);
        return { status: 500, message: err.message || 'An error occurred' };
    }
};

//-------------------------------------------------------------------------------------------------

export const download_all_vehicles_audit = async () => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/vehicle_files/download_all_vehicles_audit', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });

        if (!response.ok) {
            let message = 'Failed to download all vehicles audit';
            try {
                const body = await response.json();
                message = body.error || message;
            } catch (_) {}
            return { status: response.status, message };
        }

        const blob = await response.blob();
        const contentDisposition = response.headers.get('content-disposition') || '';
        const match = contentDisposition.match(/filename="?([^";]+)"?/i);
        const fileName = (match && match[1]) ? match[1] : 'All_Vehicles_Audit.pdf';
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        return { status: 200, message: 'All vehicles audit downloaded successfully' };
    } catch (err) {
        logger.error('Error downloading all vehicles audit:', err);
        return { status: 500, message: err.message || 'An error occurred' };
    }
};

//-------------------------------------------------------------------------------------------------

export const download_vehicle_files_zip = async (vehicleId, vehicleReg) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch(`/vehicle_files/download_vehicle_files_zip/${vehicleId}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });

        if (!response.ok) {
            let message = 'Failed to download vehicle files';
            try {
                const body = await response.json();
                message = body.error || message;
            } catch (_) {}
            return { status: response.status, message };
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `Vehicle_Files_${vehicleReg || vehicleId}.zip`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        return { status: 200, message: 'Files downloaded successfully' };
    } catch (err) {
        logger.error('Error downloading vehicle files zip:', err);
        return { status: 500, message: err.message || 'An error occurred' };
    }
};

//-------------------------------------------------------------------------------------------------

export const download_all_vehicles_files_zip = async (onProgress = () => {}) => {
    let progressTimer = null;
    let isPolling = true;
    let lastProgress = { processed: 0, total: 0, percentage: 0 };
    try {
        const sessionToken = await getSessionUUID();
        const processUuid = window.crypto.randomUUID();
        const responsePromise = fetch(`/vehicle_files/download_all_vehicles_files_zip?process_uuid=${processUuid}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });

        const pollProgress = async () => {
            try {
                const progressResponse = await fetch(
                    `/vehicle_files/download_all_vehicles_files_zip_progress/${processUuid}`,
                    { headers: { 'Authorization': `Bearer ${sessionToken}` } }
                );
                if (progressResponse.ok && isPolling) {
                    lastProgress = await progressResponse.json();
                    onProgress(lastProgress);
                }
            } catch (_) {
                // The download continues if progress tracking is temporarily unavailable.
            }
        };

        await pollProgress();
        progressTimer = window.setInterval(pollProgress, 500);
        const response = await responsePromise;

        if (!response.ok) {
            let message = 'Failed to download all vehicle files';
            try {
                const body = await response.json();
                message = body.error || message;
            } catch (_) {}
            return { status: response.status, message };
        }

        const blob = await response.blob();
        const contentDisposition = response.headers.get('content-disposition') || '';
        const match = contentDisposition.match(/filename="?([^";]+)"?/i);
        const fileName = (match && match[1]) ? match[1] : 'All_Vehicles_Files.zip';
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        onProgress({ ...lastProgress, percentage: 100, message: 'Download complete', completed: true });
        return { status: 200, message: 'All vehicle files downloaded successfully' };
    } catch (err) {
        logger.error('Error downloading all vehicle files zip:', err);
        return { status: 500, message: err.message || 'An error occurred' };
    } finally {
        isPolling = false;
        if (progressTimer !== null) {
            window.clearInterval(progressTimer);
        }
    }
};

//-------------------------------------------------------------------------------------------------

export const download_missing_docs_report = async () => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/vehicle_files/download_missing_docs_report', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`,
            },
        });

        if (!response.ok) {
            let message = 'Failed to generate missing documents report';
            try {
                const body = await response.json();
                message = body.error || message;
            } catch (_) {}
            return { status: response.status, message };
        }

        const blob = await response.blob();
        const contentDisposition = response.headers.get('content-disposition') || '';
        const match = contentDisposition.match(/filename="?([^";]+)"?/i);
        const fileName = (match && match[1]) ? match[1] : 'Missing_Documents_Report.pdf';
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        return { status: 200, message: 'Missing documents report downloaded successfully' };
    } catch (err) {
        logger.error('Error downloading missing documents report:', err);
        return { status: 500, message: err.message || 'An error occurred' };
    }
};